<template>
  <el-card
    id="overviewTop"
    v-loading="loading"
    shadow="hover"
    class="mainCard clear-card"
    :body-style="{padding: '20px 30px'}"
  >
    <div class="content">
      <div
        v-if="['desktop', 'laptop'].includes($mq)"
        class="title defaultCursor"
      >
        {{ $t('actionPlan.actionPlanProgress') }}
      </div>

      <OverviewChart
        v-if="stats"
        :chart-data="stats"
        class="graph"
      />
    </div>

    <div
      v-if="!pastEngagement"
      class="btnWrap"
    >
      <el-row
        style="display: flex; justify-content: center;"
        :gutter="5"
      >
        <el-col :span="responsiveCol">
          <el-button
            class="draftBtn"
            type="default"
            round
            @click="goTo('actionPlanSetUp')"
          >
            {{ setUpBtnLabel }}
          </el-button>
        </el-col>
        <el-col
          v-if="role_type === 'leader'"
          :span="responsiveCol"
        >
          <el-button
            v-if="false"
            type="primary"
            round
            @click="goTo('create')"
          >
            {{ $t('actionPlan.createPublishAP') }}
          </el-button>
          <el-button
            v-else
            type="primary"
            round
            :disabled="status !== 'published'"
            @click="goTo('actionPlanSurvey')"
          >
            {{ $t('actionPlan.takeSurvey') }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {
    OverviewChart: () => import(/* webpackChunkName: "Charts" */ './OverviewChart.vue'),
  },

  props: {
    pastEngagement: {
      type: Boolean,
      default: false,
    },

    submitted: {
      type: Boolean,
      default: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    status: {
      type: String,
      default: 'draft',
    },

    stats: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapState({
      role_type: (state) => state.user.user.role_type,
    }),

    responsiveCol() {
      let col = 12;
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col = 24;
      }
      return col;
    },

    setUpBtnLabel() {
      let label = this.$t('actionPlan.draftAP');
      if (this.status === 'published') {
        label = this.$t('actionPlan.draftNextAP');
      }
      return label;
    },
  },

  methods: {
    goTo(option) {
      let formattedOption = option;
      if (option === 'actionPlanSetUp' && this.role_type === 'coach') {
        formattedOption = 'myLeaderActionPlanSetUp';
      }
      switch (formattedOption) {
        case 'actionPlanSurvey':
          if (this.submitted) {
            this.$alert(this.$t('actionPlan.alreadySubmitted'), '', {
              confirmButtonText: 'OK',
            });
          } else {
            this.$router.push({ name: formattedOption }).catch((err) => {});
          }
          break;
        case 'myLeaderActionPlanSetUp':
          this.$router.push({ name: formattedOption, params: { id: this.$route.params.id } });
          break;
        default:
          this.$router.push({ name: option }).catch((err) => {});
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#overviewTop {
  .content {
    padding: 5px;
    min-height: 390px;

    .title {
      font-weight: bold;
    }

    > .graph {
      margin-left: -22px;
    }
  }

  .btnWrap {
    width: 100%;
    align-self: center;
    margin-top: -20px;

    .el-row {
      .el-col {
        text-align: center;
        padding: 10px 0 15px;

        .el-button {
          width: 80%;
          padding: 13px 0;

          span {
            display: inline-block;
            width: 100%;
            white-space: normal;
            word-break: break-word;
          }

          &.draftBtn {
            background: transparent;
            color: var(--themeFontColor);

            &:hover {
              background: rgba(255, 255, 255, 0.2);
            }
          }
        }
      }
    }
  }
}
</style>
